// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"259":"32e5821b","397":"cc0b64ce","484":"3f920105","578":"fbc8fbdf"}[chunkId] + ".chunk.css";
};